// import models
import * as PATH from '@src/configs/paths'
import { IMenuItem } from '@src/types/menu'

export const MainMenu: IMenuItem[] = [
    {
        label: 'Swap',
        active: 'active',
        inactive: 'inactive',
        navigation: PATH.SWAP,
    },
    {
        label: 'Orders',
        active: 'active',
        inactive: 'inactive',
        navigation: PATH.ORDERS,
    },
    {
        label: 'Miles',
        active: 'active',
        inactive: 'inactive',
        navigation: PATH.POINTS,
    },
    {
        label: 'Developers',
        active: 'active',
        inactive: 'inactive',
        navigation: PATH.DEVS,
        target: '_blank',
    },
    {
        label: 'Docs',
        active: 'active',
        inactive: 'inactive',
        navigation: PATH.DOCS,
        target: '_blank',
    },
]
